// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9b0d1299","104":"17a7338d","453":"983c386a"}[chunkId] + ".chunk.js";
};